export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14054.bef89f9d.jpg";